/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsUpdateDomain } from "../funcs/domainsUpdateDomain.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CustomDomain } from "../models/components/customdomain.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateDomainRequest,
  UpdateDomainSecurity,
} from "../models/operations/updatedomain.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateDomainMutationVariables = {
  request: UpdateDomainRequest;
  security?: UpdateDomainSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateDomainMutationData = CustomDomain;

export type UpdateDomainMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateDomain domains
 *
 * @remarks
 * Update settings for the organization's custom domain
 */
export function useUpdateDomainMutation(
  options?: MutationHookOptions<
    UpdateDomainMutationData,
    UpdateDomainMutationError,
    UpdateDomainMutationVariables
  >,
): UseMutationResult<
  UpdateDomainMutationData,
  UpdateDomainMutationError,
  UpdateDomainMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateDomainMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateDomain(): MutationKey {
  return ["@gram/client", "domains", "updateDomain"];
}

export function buildUpdateDomainMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateDomainMutationVariables,
  ) => Promise<UpdateDomainMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateDomain(),
    mutationFn: function updateDomainMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateDomainMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(domainsUpdateDomain(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
